__turbopack_context__.v({
  "attributesSkeleton": "AiqFuq_attributesSkeleton",
  "modalContent": "AiqFuq_modalContent",
  "productGrid": "AiqFuq_productGrid",
  "scrollableItemRow": "AiqFuq_scrollableItemRow",
  "seeMoreText": "AiqFuq_seeMoreText",
});
